import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const cardHeader = "px-4 pt-3 pb-1.5 sm:px-4 sm:pt-3 sm:pb-1.5";

const cardTitle = "text-sm font-semibold tracking-tight truncate";

const cardContent = "px-4 pt-1.5 pb-4 sm:px-4 sm:pt-1.5 sm:pb-4 flex flex-col gap-1";

const statusBadge = "ml-auto shrink-0 w-24 text-center text-[11px] font-medium px-1.5 py-0.5 rounded-md border";

const invoiceAmount = "shrink-0 text-sm font-bold text-foreground tracking-tight tabular-nums";

const statusNoInvoice = "ml-auto shrink-0 text-xs text-muted-foreground/60";

const providerRow = cn("flex items-center gap-2.5 rounded-md px-2 py-2", shared.transitionColors);

const providerTile = "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg";

const providerRowLinkable = "hover:bg-muted/60 cursor-pointer";

export { cardHeader, cardTitle, cardContent, statusBadge, invoiceAmount, statusNoInvoice, providerRow, providerTile, providerRowLinkable };
